import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import Notification from './Notification';

let NotificationHistory = () => {
  let [data, setData] = useState();

  let [pikk, setPikk] = useState("XOPAY");

  let [pikks, setPikks] = useState("");

  let [show, setShow] = useState(false);
  let [indexs1, setIndex1] = useState(0);
  let [indexs1a, setIndex1a] = useState(0);
  let [count, setCount] = useState();
  let [counts, setCounts] = useState();
  let [indexs, setIndex] = useState(0);
  let [indexsa, setIndexa] = useState(0);
  let [showModal, setShowModal] = useState(false);
  let [selectedNotification, setSelectedNotification] = useState(null);

  let [ searchvalue , setSearchValue ] = useState("")
  let [ currentvalue , setCurrentvlaue ] = useState()

  let [ loading , setLoading ] = useState(false)

  let navigate = useNavigate();


  const [isFourToFivePM, setIsFourToFivePM] = useState(false);

  // Function to check the current time
  const checkTime = () => {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    if (hours === 16 && minutes >= 0 && minutes < 60) {
      setIsFourToFivePM(true);
    } else {
      setIsFourToFivePM(false);
    }
  };

  useEffect(() => {
    // Check time immediately
    checkTime();

    // Set an interval to check the time every minute
    const interval = setInterval(checkTime, 60000); // 60000 ms = 1 minute

    // Clean up the interval on component unmount
    return () => clearInterval(interval);
  }, []);



  useEffect(() => {
    Start();
    newstart() 
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };
 
  let newstart = async () => {
 
    let apicall = await axios({
        method: "post",
        url: Base_url + "/common/sendnoticount",
        data :{
          page : 0 ,
          limit : 10
        }
      })
       .then((dat) => { 

          console.log(dat.data.data, "Jsson");
          if (dat.data.status === true) { 
            setData(dat.data.data)
            setCount(dat.data.count)
          } else { 

          }
        })
        .catch((ee) => {
          console.log(ee)  
        });
  };
 
 

  const handlePageClick = async (event) => {
    console.log(event.selected);
    setIndex(event.selected);
    setIndex1(event.selected); 

    let newstart = async (count) => {
      let apicall = await axios({
          method: "post",
          url: Base_url + "/common/sendnoticount",
          data :{
            page : count ,
            limit : 10
          }
        })
        .then((dat) => { 

            console.log(dat.data.data, "Jsson");
            if (dat.data.status === true) { 
              setData(dat.data.data)
              setCount(dat.data.count)
            } else { 

            }
          })
          .catch((ee) => {
            console.log(ee)  
          });
    };

    newstart(event.selected);
   
  };
 

 
  let handleClick = async (dat) => {

    setCurrentvlaue(dat)
    setLoading(true)
 
 

       let apicall = await axios({
          method: "post",
          url: Base_url + "/common/sendnoticountuser",
          data :{
            page : 0 ,
            limit : 10 ,
            un_id : dat.un_id
          }
        })
        .then((dat) => { 
           setLoading(false)

            console.log(dat.data.data, "Jsson");
            if (dat.data.status === true) { 
              setSelectedNotification(dat.data.data)
              setCounts(dat.data.count)

              setShowModal(true);
            } else { 

            }
          })
          .catch((ee) => {
            setLoading(false)
            console.log(ee)  
          });  
          
  }
 
  const closeModal = () => {
    setShowModal(false);
    setSelectedNotification(null);
  };


  let Apicall = async () => {

    let apicall = await axios({
          method: "post",
          url: Base_url + "/common/sendnotiuserbyuser",
          data :{ 
            phoneno  :  searchvalue,
            un_id    :  currentvalue.un_id
          }
        })
        .then((dat) => { 

          console.log(dat.data, "Jsson wrgeg");

          alert(dat.data.message)
 
            if (dat.data.status === true) { 


            } else { 

            }
          })
          .catch((ee) => {
            console.log(ee)  
          });  


  }


  let downloadExcel = async () => {

    let requestData = {
      un_id    :  currentvalue.un_id
    }


    const response = await axios.post(
        Base_url + "/common/sendnotiuserfaileddownload",
        requestData,
        {
          responseType: "blob", // Important to set the response type to blob for binary data
        }
      );

      // Create a URL for the blob object
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link element, set the URL as href, and trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "output.xlsx"); // Set the file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);


  }

  return (
    <div>
      <div className="row">
        <Header />
        <div className="col-10">
          <div className="row">

            <p style={{ fontWeight: "700" , marginTop : 20  , fontSize : 18 }}>Notification History</p>


            <ReactPaginate
             forcePage={indexs1}
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={count / 10}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              containerClassName="pagination justify-content-center"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
              breakClassName="page-item"
              breakLinkClassName="page-link"
            />

            <div >
              {
                data && data?.map((dat, index) => {

                  return(

                    <div className="row" key={index} style={{ borderTop : '1px solid #ccc' , paddingBottom : 10 , marginBottom : 10 ,   }}>
                      <div className="col-6" >
                        <p style={{ fontWeight: "600" , marginTop : 20  }}>{dat.content} </p>
                        <p style={{ fontSize : 14  }}>{dat.deceription} </p>
                        <p style={{ fontSize : 12 , color : 'gray'  }}>{new Date(dat.createdAt).toLocaleString()}</p>
                      </div>
                      <div className="col-6" >
                        <p style={{ fontSize : 12 , color : 'gray' , marginTop : 20 }}> Notification Id :  {dat?.un_id || ""}</p>
                        <div className="row" >
                          <button onClick={() => handleClick(dat)} className="btn btn-primary"
                           style={{ marginTop : 20 , marginLeft : 100 , width : 150 }}>{ loading === true ? "Loading..." : "View"}</button>
                        </div>
                      </div> 
                    </div>

                  )

                })
              }
            </div>
            
          </div>
           

 
        </div>
      </div>

      {/* Popup Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000
          }}
          onClick={closeModal}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "40px",
              borderRadius: "8px",
              maxWidth: "900px",
              width: "90%",
              maxHeight: "80vh",
              overflowY: "auto",
              position: "relative",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeModal}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                backgroundColor: "#f0f0f0",
                border: "none",
                borderRadius: "50%",
                width: "35px",
                height: "35px",
                fontSize: "24px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              ×
            </button>
 
              <div>
                <h6>Notification User Details:  <span style={{  fontWeight : "700" , fontSixe : 24}} >Total : { counts}</span></h6>

                <p style={{ marginTop : 20 , marginBottom : 10 }}>Search user By phone Number</p>
                <input style={{  marginBottom : 20 , width : '40%' }} type="text" onChange={
                  (e)=>{ setSearchValue(e.target.value) }
                } value={searchvalue} style={{ width: "100%" }} placeholder="Search user By phone Number" />


                <button onClick={()=>{
                  Apicall()
                }} style={{ marginTop : 10 }} >Search</button>

                <button onClick={()=>{
                  downloadExcel()
                }} style={{ marginTop : 10 }} >Download Failed User Excel</button> 

                <div style={{ marginTop : 20  }}>





                 
                  </div>
                
                 
              </div> 
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationHistory;